var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconmetroProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.001,
    height: 38.79,
    viewBox: "0 0 53.001 38.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-profile",
    "data-name": "Icon metro-profile",
    d: "M53.714,13.254H50.008V7.827l-7.651-.115.04,5.541H19.405l.157-5.541-7.492.115v5.541l-3.786-.115A3.742,3.742,0,0,0,4.5,16.948v25.86A3.742,3.742,0,0,0,8.285,46.5h45.43A3.742,3.742,0,0,0,57.5,42.808V16.948A3.742,3.742,0,0,0,53.714,13.254ZM44.25,9.559h3.786v7.389H44.25ZM19.642,22.142c2.287,0,4.142,2.377,4.142,5.311s-1.855,5.311-4.142,5.311S15.5,30.386,15.5,27.452s1.855-5.311,4.142-5.311ZM13.963,9.559h3.786v7.389H13.963ZM11.44,39.017s.449-3.513,1.469-4.176a14.8,14.8,0,0,1,3.956-1.1s1.9,1.986,2.714,1.986,2.713-1.986,2.713-1.986a14.754,14.754,0,0,1,3.958,1.1c1.2.779,1.5,4.176,1.5,4.176H11.44Zm38.488-1.751H32.892V35.419H49.928Zm0-3.694H32.892V31.725H49.928Zm0-3.694H32.892V28.031H49.928Zm0-3.694H32.892V24.336H49.928Z",
    transform: "translate(-4.499 -7.712)",
    fill: "#0c8de0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmetroProfile);
export default __webpack_public_path__ + "static/media/Icon metro-profile.b9f0d0ef8c8cf7f607038482494ccd0f.svg";
export { ForwardRef as ReactComponent };